import Message from 'element-ui/lib/message';
import md5 from 'js-md5';
import HmacSHA256 from 'crypto-js/hmac-sha256';
import Base64 from 'crypto-js/enc-base64';
import { apiBase, mapiBase } from './env';
import User from './user';
import utils from './utils';
import Store from '../store/store';
import { palmyouUrl } from './palmyou-url';

// 鉴权的配置
const authConfig = {
  'ssq-www': {
    access_key: 'LODAPgyfDbBIKCLR',
    secret_key: 'T4SwFDKdfPJlbIpFdIq8e51ChJ3ZPn20',
    version: '1.0.0',
    platform: 10,
  },
  vms: {
    access_key: 'Lv8O6VwBbN2qzuUb',
    secret_key: 'LlrYOcAUYJtuHT0X5leEXngQzSIz6Nln',
    version: '1.0.0',
    platform: 10,
  },
};

export default {
  buildHeader(platform = '13') {
    const header = {
      ver: '1.0.0',
      noncestr: utils.ranString(16),
      platform,
    };

    header.sign = md5(`version=${header.ver}&noncestr=${header.noncestr
    }&platform=${header.platform}&secretkey=3CA6549DDFC3D9FFA1F766D8944CAD67`).toLowerCase();

    return header;
  },

  // 获取http授权头
  getHttpAuthHeader(options) {
    const finnalOptions = Object.assign(
      {},
      {
        type: 'ssq-www',
      },
      options,
    );
    const currnetAuthConfig = authConfig[finnalOptions.type];
    const RequestId = utils.ranString(32);
    const gmtDateStr = new Date().toGMTString();

    const str = `${currnetAuthConfig.access_key}\n${gmtDateStr}\n${
      currnetAuthConfig.version
    }\n${RequestId}`;

    const auth = Base64.stringify(HmacSHA256(str, currnetAuthConfig.secret_key));

    const headers = {
      'X-Version': currnetAuthConfig.version,
      'X-Date': gmtDateStr,
      'X-Request-Id': RequestId,
      Authorization: `Basic ${auth}`,
      platform: currnetAuthConfig.platform,
    };
    if (User.token) {
      headers['X-Token'] = User.token;
    }
    return headers;
  },

  getCompateNewUrl(url) {
    let result = '';
    if (url.indexOf('/sys') > -1) {
      result = apiBase.substring(0, apiBase.length - ('/peer'.length)) + url;
    } else {
      result = apiBase + url;
    }
    return result;
  },

  post(url, data, opts) {
    opts = opts || {};
    const reqUrl = opts.url ? opts.url : this.getCompateNewUrl(url);

    return new Promise(((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('post', reqUrl);

      xhr.setRequestHeader('content-type', 'application/json');

      if (!opts.header) {
        const headers = this.getHttpAuthHeader();
        Object.keys(headers).forEach((key) => {
          xhr.setRequestHeader([key], headers[key]);
        });
      }

      if (opts.header) {
        Object.keys(opts.header).forEach((k) => {
          xhr.setRequestHeader(k, opts.header[k]);
        });
      } else if (User.token) {
        xhr.setRequestHeader('token', User.token);
      }

      xhr.onload = function (e) {
        try {
          if (e.target.status !== 200) {
            if (e.target.status === 401) {
              User.logout(opts.stay);

              // 如果是金棕榈就跳转到金棕榈的过度界面
              const isPalmyou = Store.state.user && Store.state.user.userInfo && Store.state.user.userInfo.is_palmyou;
              if (isPalmyou) {
                location.replace(palmyouUrl);
              }

              if (!opts.noToast) {
                opts.noToast || Message.error('登录已过期，请重新登录');
              }
            } else if (e.target.status === 403) {
              Message.error('访问禁止的内容，请检查电脑设置的时间是否与北京时间一致');
              // location.replace('/');
            } else if (e.target.status === 405) {
              Store.dispatch('user/peerAccountQuery').then((data) => {
                // User.login(data);
                User.login(utils.extend({}, data, { token: User.token, is_palmyou: User.is_palmyou }), +localStorage.getItem('remember'));
                // 解决不知道哪些接口会不一样，直接刷页面
                window.location.reload();
              });
            } else {
              opts.noToast || Message.error('抱歉，出错了，请重试或联系客服');
            }

            return reject('');
          }

          let res = e.target.response;

          if (opts.noParse) {
            return resolve(res);
          }
          res = JSON.parse(res);
          if (res.ret === 0) {
            resolve(res.body);
          } else {
            reject(res);
            opts.noToast || Message.error(res.msg || '抱歉，出错了，请重试或联系客服');
          }
        } catch (err) {
          opts.noToast || Message.error('抱歉，出错了，请重试或联系客服');
          return reject('');
        }


      };

      xhr.onerror = function () {
        reject('');
        opts.noToast || Message.error('抱歉，出错了，请重试或联系客服');
      };
      xhr.send(JSON.stringify(data));
    }));
  },

  mPost(url, data, options) {
    return this.post('', data, Object.assign({}, options, {
      url: `${mapiBase}${url}`,
      header: this.getHttpAuthHeader({ type: 'vms' }),
    }));
  },
};



// WEBPACK FOOTER //
// ./src/libs/http.js